import React, { useState, useEffect } from "react";
import Input from "../../components/Input";
import axios from "../../axios";
import Overlay from "../../components/Overlay";
import { get } from "lodash";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { Modal } from "../../components/Modal";
import {
    extractDate,
    uploadImage,
    subadminAccessChange,
} from "../../utils/functions";

// Mui & material UI
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import SearchBar from "material-ui-search-bar";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import PaginationItem from "@mui/material/PaginationItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
    Paper,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
} from "@material-ui/core";

// icons
import { RxCross2 } from "react-icons/rx";
import { IoIosLogOut } from "react-icons/io";
import { TiInfoOutline } from "react-icons/ti";
import { BiSolidPackage } from "react-icons/bi";
import { RxCrossCircled } from "react-icons/rx";
import { SlClose } from "react-icons/sl";
import { SiChase } from "react-icons/si";
import { RiEdit2Line } from "react-icons/ri";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { GrApple, GrAndroid } from "react-icons/gr";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { BsDot, BsEyeFill, BsPlus, BsThreeDotsVertical } from "react-icons/bs";
import { PiHandsClappingBold, PiUserList, PiXCircleFill } from "react-icons/pi";
import {
    MdBlock,
    MdClose,
    MdEmail,
    MdLocalPhone,
    MdPhone,
} from "react-icons/md";
import {
    IoArchive,
    IoArrowBackCircleOutline,
    IoArrowForwardCircleOutline,
} from "react-icons/io5";
import {
    FaFilter,
    FaGlobe,
    FaPhone,
    FaUser,
    FaUserAlt,
    FaMoneyBill,
    FaCheckCircle,
    FaArrowLeft,
} from "react-icons/fa";

// Elements
import {
    DashboardContainer,
    DashboardWrapper,
    ServiceDetailForm,
    ProfileDetailForm,
    DashHeading,
    Button,
    DeleteButton,
    SelectedColumnContainer,
    Filter,
    DpBox,
    Fields,
    Resetbtn,
    Applybtn,
} from "./SubAdminElements.js";
import CustomSelect from "../../components/CustomSelect";
import NoResults from "../../components/NoResult";

const useStyles = makeStyles((theme) => ({
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "67vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",

        // border: "1px solid rgba(17, 153, 38, 0.20)",

        // Optional scrollbar customization
        '&::-webkit-scrollbar': {
            height: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#5088FB',     // Scrollbar color
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
        },
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        // border: "1px solid rgba(17, 153, 38, 0.20)",

    },
    tableBodyRow: {
        background: "#FFFFFF",
        border: "1px solid rgba(17, 153, 38, 0.20)",

        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        // padding: "0.5rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        fontWeight: "500",
        // border: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
        background: "#FFFFFF",
        border: "none"
    },
    textMiddle: {
        padding: "0.3rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#484848",
        fontFamily: "Roboto",
        fontWeight: "400",
        background: "#FFFFFF",
        border: "none",
        width: "10rem"
    },
    tablePaginationStyle: {
        borderTop: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));

const SubAdminManagement = ({ setUsers, userData }) => {
    const param = useParams();
    const location = useLocation();
    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);


    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(1); // Reset to the first page when rows per page change
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Update page and trigger data fetch
    };


    // For Select checkbox
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (tableData.length === 0) {
            setSelectedRows([]);
        }
    }, [tableData]);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedRows(tableData.map((item) => item._id));
        } else {
            setSelectedRows([]);
        }
    };

    const handleSelectRow = (id) => {
        const newSelectedRows = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];
        setSelectedRows(newSelectedRows);
    };

    const handleClearSelection = () => {
        setSelectedRows([]);
    };


    // For Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    function myDeb(call, d = 1000) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                call(...args);
            }, d);
        };
    }

    const SearchFeedbackManagement = myDeb((search) => {
        setSelectedRows([]);
        setSearchTerm(search);
        setPage(1); // Reset to the first page on search
    });

    const cancelSearch = () => {
        setSearchTerm("");
        setPage(1); // Reset to the first page when search is canceled
    };


    // Get all SubAdmin
    useEffect(() => {
        getAllSubAdmin();
    }, [page, rowsPerPage, searchTerm]);

    const getAllSubAdmin = async () => {
        setIsLoading(true);

        try {
            const { data } = await axios.get(
                `/private/getAllSubAdmins?page=${page}&limit=${rowsPerPage}&search=${searchTerm}`
            );

            setTableData(data?.data?.docs);
            setTotalDocs(data?.data?.totalDocs);
        } catch (error) {
            if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else {
                console.log("error", error?.response);
            }
        } finally {
            setIsLoading(false);
        }
    };

    // Delete SubAdmin functionality - handles both single and multiple deletions
    const DeleteSubAdmin = async (id = null) => {
        const idsToDelete = id ? [id] : selectedRows;

        if (idsToDelete.length === 0) {
            toast.error("No SubAdmin selected for deletion", {
                position: "top-right",
            });
            return;
        }

        setIsLoading(true);

        try {
            // Using axios.request to support sending data in the body with DELETE method
            const { data } = await axios({
                method: "post",
                url: `/private/deleteSubAdmins`,
                data: {
                    ids: idsToDelete,
                },
            });

            toast.success(data?.message);
            setSelectedRows([]); // Clear selected rows after deletion
            getAllSubAdmin();
            setDeleteModal(false); // Close the modal
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else {
                toast.error("Something went wrong", {
                    position: "top-right",
                });
            }
        } finally {
            setIsLoading(false);
        }
    };


    // This is for manage status dropdown
    const [selectedSubadminOption, setSelectedSubadminOption] = useState({});

    const statusOptions = {
        1: {
            options: [{ value: "3", label: "Cancel invitation" }, { value: "2", label: "Resend invitation" }],
            color: "#F3F7FF",
            textColor: "#5088FB",
            placeholder: "Invitation Sent"
        },
        2: {
            options: [{ value: "2", label: "Resend invitation" }],
            color: "#FFf4E2",
            textColor: "#FDA517",
            placeholder: "Expired"
        },
        3: {
            options: [{ value: "1", label: "Edit" }, { value: "4", label: "Block" }, { value: "6", label: "View History" }],
            color: "#EAFFED",
            textColor: "#2CA63F",
            placeholder: "Active"
        },
        4: {
            options: [{ value: "5", label: "Unblock" }],
            color: "#FFEFEF",
            textColor: "#FF493A",
            placeholder: "Blocked"
        },
        5: {
            options: [{ value: "2", label: "Resend invitation" }],
            color: "#FFEFEF",
            textColor: "#FF493A",
            placeholder: "Invite Cancelled"
        }
    };

    const handleSelectChange = async (selectedOption, admin) => {
        const apiEndpoints = {
            "1": () => navigate(`/subAdminDetail`, { state: { admin } }), // Edit
            "2": `/private/resendInvitaion/${admin?.subadmins?._id}`, // Resend Invitation
            "3": `/private/cancelInvitation/${admin?.subadmins?._id}`, // Cancel Invitation
            "4": `/private/blockSubAdmin/${admin?.subadmins?._id}`, // Block
            "5": `/private/unblockSubAdmin/${admin?.subadmins?._id}`, // Unblock
            "6": () => navigate(`/subAdminDetailHistory/${admin?.subadmins?._id}`, {
                state: { from: "subAdminManagement", tabStatus: page, rowsPerPage }
            }), // History
        };

        console.log("object", admin?.subadmins?._id);

        if (selectedOption.value === "1") {
            apiEndpoints["1"](); // navigate to Edit page
            return; // 
        }

        if (selectedOption.value === "6") {
            apiEndpoints["6"](); // navigate to History page
            return; //
        }

        try {
            let response;
            if (selectedOption.value === "4" || selectedOption.value === "5") {
                const isBlocked = selectedOption.value === "4";
                response = await axios.post(apiEndpoints[selectedOption.value], { isBlocked });
            } else {
                response = await axios.get(apiEndpoints[selectedOption.value]);
            }
            getAllSubAdmin();
            toast.success(`${response.data.message}`, { position: "top-right" });
        } catch (error) {
            if (error.response?.status === 422) {
                toast.error(`${error.response?.data?.msg}`, { position: "top-right" });
            } else {
                toast.error("Something went wrong !!", { position: "top-right" });
            }
        }

        // Reset selected option
        setSelectedSubadminOption(prev => ({ ...prev, [admin?.subadmins?._id]: null }));
    };

    return (
        <>
            <DashboardContainer>
                <DashboardWrapper>
                    <ProfileDetailForm>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <div className="common-heading ps-2">Sub Admin Management</div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem"
                                }}
                            >

                                <Button
                                    type="button"
                                    style={{ background: "#5088FB", color: "#ffffff" }}
                                    onClick={() => {
                                        navigate("/subAdminDetail");
                                    }}
                                >
                                    <BsPlus
                                        style={{
                                            color: "#ffffff",
                                            marginRight: "6px",
                                            fontSize: "1.5rem",
                                        }}
                                    />
                                    Add Sub Admin
                                </Button>
                            </div>
                        </div>

                        {selectedRows.length > 0 && (
                            <SelectedColumnContainer>
                                <DeleteButton
                                    type="button"
                                    className="buttonWidthResponsive"
                                    onClick={() => {
                                        setDeleteModal(true);
                                    }}
                                >
                                    Delete
                                </DeleteButton>
                                <div className="column-selected">
                                    {selectedRows.length} Selected
                                </div>
                                <div
                                    className="container-clear-selection"
                                    onClick={handleClearSelection}
                                >
                                    <RxCrossCircled />
                                    <span className="column-selected">Clear Response</span>
                                </div>
                            </SelectedColumnContainer>
                        )}

                        <TableContainer className={classes.tableMainContainer}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHeadingRow}>
                                        <TableCell
                                            className={classes.tableHeadingCell}
                                            style={{ textAlign: "left" }}
                                        >
                                            <div style={{ display: "flex", gap: "2rem" }}>
                                                <Checkbox
                                                    style={{ padding: "2px", marginLeft: "0.6rem" }}
                                                    indeterminate={selectedRows.length > 0 && selectedRows.length < tableData.length}
                                                    checked={tableData.length > 0 && tableData.every((item) => selectedRows.includes(item._id))}
                                                    onChange={handleSelectAll}
                                                    color="primary"

                                                />
                                                <div>S.No</div>
                                            </div>
                                        </TableCell>
                                        {/* <TableCell className={classes.tableHeadingCell}>
                                            S.No
                                        </TableCell> */}
                                        <TableCell className={classes.tableHeadingCell}>
                                            Status
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Sub Admin Id
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "3rem" }}>
                                                Sub Admin Title
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "3rem" }}>
                                                Sub Admin Name
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>

                                            Sub Admin Email
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Last Active
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {tableData && tableData.length > 0 ? (
                                    <>
                                        <TableBody>
                                            {tableData.map((admin, index) => (
                                                <TableRow
                                                    className={classes.tableBodyRow}
                                                    key={admin._id}
                                                >
                                                    <TableCell
                                                        className={classes.textMiddle}
                                                        style={{ textAlign: "left" }}
                                                    >
                                                        <div style={{ display: "flex", gap: "2.3rem" }}>
                                                            <Checkbox

                                                                style={{ padding: "2px" }}
                                                                checked={selectedRows.includes(admin._id)}
                                                                onChange={() => handleSelectRow(admin._id)}
                                                                color="primary"
                                                            //disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                                            // disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                                            />
                                                            <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                        </div>
                                                    </TableCell>

                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                            {statusOptions[admin?.subadmins?.subAdminStatus] && (

                                                                <CustomSelect
                                                                    admin={admin}
                                                                    statusOptions={statusOptions}
                                                                    handleSelectChange={handleSelectChange}
                                                                />
                                                            )}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        {get(admin, "subAdminDetailId", "---")}
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{
                                                            textTransform: "capitalize",
                                                            textAlign: "left",
                                                            marginLeft: "3rem"

                                                        }}>
                                                            {get(admin, "subAdminTitle", "---")}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{
                                                            textTransform: "capitalize",
                                                            textAlign: "left",
                                                            marginLeft: "3rem"
                                                        }}>
                                                            {get(admin, "subadmins.firstName", "---")}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>

                                                        {get(admin, "subadmins.email", "---")}
                                                        {/* </div> */}
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        {extractDate(get(admin, "subadmins.lastActive"))}

                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </>
                                ) : (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell
                                                    colSpan={8}
                                                    align="center"
                                                    style={{ padding: "2rem", borderBottom: "none" }}
                                                >
                                                    <DashHeading
                                                        style={{ textAlign: "center", padding: "2rem" }}
                                                    >
                                                        <NoResults />
                                                    </DashHeading>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {(tableData && tableData.length > 0) && (
                            <>
                                <Stack spacing={2} className={classes.paginationContainer}>
                                    <Pagination
                                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                        page={page}
                                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{
                                                    previous: HiMiniArrowLeft,
                                                    next: HiMiniArrowRight,
                                                }}
                                                {...item}
                                            />
                                        )}
                                    />
                                </Stack>
                            </>
                        )}
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer>

            {/* Modal for Delete Feedback  */}
            <Modal
                maxWidth="lg"
                width="360px"
                RoundedCorners={true}
                isOpen={deleteModal}
                onClose={() => {
                    setDeleteModal(false);
                }}
                backgroundModal={false}
                backgroundModalContent={false}
                title={
                    <div style={{ padding: "0 12px" }}>
                        <div className="d-flex align-items-center justify-content-end">
                            <RxCross2
                                style={{
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setDeleteModal(false);
                                }}
                            />
                        </div>
                        <p className="profile-section-text">Delete Subadmin</p>
                        <div className="logout-header" style={{ paddingTop: "0px" }}>
                            Are you sure you want to delete Subadmin? Deleting them will
                            permanently remove all their data.
                        </div>
                    </div>
                }
                content={
                    <>
                        <div className="logout-button-group">
                            <div
                                className="cancel-button"
                                onClick={() => {
                                    setDeleteModal(false);
                                }}
                            >
                                Cancel
                            </div>
                            <div
                                className="logout-button"
                                style={{ background: "#5088FB" }}
                                onClick={() => DeleteSubAdmin(null)}
                            >
                                Confirm
                            </div>
                        </div>
                    </>
                }
            />

            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubAdminManagement);

